import React from 'react';
import * as S from './PriceBlockLoader.styles';

const PriceBlockLoader = () => {
  return (
    <S.PriceBlockLoader>
      <S.HeaderWithIconWrap>
        <S.TotalPriceWrap></S.TotalPriceWrap>
        <S.ArrowDownWrap>
          <S.ArrowDown></S.ArrowDown>
        </S.ArrowDownWrap>
      </S.HeaderWithIconWrap>

      <S.TotalChargesOuterContainer>
        <S.RoomChargesOuterContainer>
          <S.RoomChargesWrap>
            <S.RoomChargesLabel></S.RoomChargesLabel>
            <S.RoomChargesPrice></S.RoomChargesPrice>
          </S.RoomChargesWrap>

          <S.RoomChargesWrap>
            <S.RoomChargesLabel></S.RoomChargesLabel>
            <S.RoomChargesPrice></S.RoomChargesPrice>
          </S.RoomChargesWrap>

          <S.RoomChargesWrap>
            <S.RoomChargesLabel></S.RoomChargesLabel>
            <S.RoomChargesPrice></S.RoomChargesPrice>
          </S.RoomChargesWrap>

          <S.RoomChargesWrap>
            <S.RoomChargesLabel></S.RoomChargesLabel>
            <S.RoomChargesPrice></S.RoomChargesPrice>
          </S.RoomChargesWrap>
        </S.RoomChargesOuterContainer>
      </S.TotalChargesOuterContainer>

      <S.DiscountWrap>
        <S.RoomChargesWrap>
          <S.RoomChargesLabel></S.RoomChargesLabel>
          <S.RoomChargesPrice></S.RoomChargesPrice>
        </S.RoomChargesWrap>
      </S.DiscountWrap>

    </S.PriceBlockLoader>
  );
};

export default PriceBlockLoader;
